/* ═══════════════════════════════════════════════════
   SUBPAGE COMMON JS
   Scroll reveal, FAQ accordion, back-to-top
   ═══════════════════════════════════════════════════ */
(function() {
  "use strict";

  // Scroll reveal
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(el) {
      if (el.isIntersecting) {
        el.target.classList.add('vis');
        obs.unobserve(el.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });

  // FAQ accordion
  document.querySelectorAll('.sp-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.closest('.sp-faq-item').classList.toggle('open');
    });
  });

  // Back to top
  var btt = document.getElementById('backTop');
  if (btt) {
    window.addEventListener('scroll', function() {
      btt.classList.toggle('show', window.scrollY > 600);
    }, { passive: true });
    btt.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();

